import newFeedApi from '../api/newFeedApi';
import newFeedItem from '../models/newFeedItem';
import activitySumary from '../models/activitySumaryUsers';
import dateFinderCount from '../models/dateFinderCount';
import activeUsersCount from '../models/activeUsersCount';
import prospectsSummaryCount from '../models/prospectsSummaryCount';
import competitionItem from '../models/competitionItem';
import recentUsers from '../models/recentUsers';
import banner from '../models/announcementBanner';
import { IApiResponse } from '../interfaces/IApiResponse';
import Feed from '../models/newFeedItem';

class NewFeedService {
  getDataPageHome(params: Record<string, any>): Promise<IApiResponse<any>> {
    return newFeedApi
      .getPageHome(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: newFeedItem.mappingObjects(res.data.items),
            };
          }
          return { success: res.success, data: [] };
        }
        console.log('ERROR: newFeedService/getDataPageHome:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: newFeedService/getDataPageHome:', e);
        return { success: false };
      });
  }

  getDataPageHomeWithPinnedContent(params: Record<string, any>): Promise<IApiResponse<Feed[]>> {
    return newFeedApi
      .getPageHomeWithPinnedContent(params)
      .then(res => {
        if (res.success) {
          if (res.data) {
            return {
              success: res.success,
              data: newFeedItem.mappingObjects(res.data.Stream || []),
              dataPinnedContent: newFeedItem.mappingObjects(res.data.Pins || []),
              dataDateFinder: newFeedItem.mappingObjects(res.data.DateFinder || []),
            };
          }
          return { success: res.success, data: [], dataPinnedContent: [] };
        }
        console.log('ERROR: newFeedService/getDataPageHomeWithPinnedContent:', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: newFeedService/getDataPageHomeWithPinnedContent:', e);
        return { success: false };
      });
  }

  getActivitySumaryUser(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getActivitySumaryUser()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: activitySumary.mappingObject(res.data),
          };
        }
        console.log('ERROR: newFeedService/getActivitySumaryUsers', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getActivitySumaryUsers', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getActivitySumaryUsers' };
      });
  }

  getDateFinderCount(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getDateFinderCount()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: dateFinderCount.mappingPropertyObject(res.data),
          };
        }
        console.log('ERROR: newFeedService/getDateFinderCount', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getDateFinderCount', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getDateFinderCount' };
      });
  }

  getActiveUsersCount(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getActiveUsersCount()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: activeUsersCount.mappingPropertyObject(res.data),
          };
        }
        console.log('ERROR: newFeedService/getActiveUsersCount', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getActiveUsersCount', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getActiveUsersCount' };
      });
  }

  getProspectSummaryCount(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getProspectsSummaryCount()
      .then(res => {
        if (res.success) {
          return {
            success: res.success,
            data: prospectsSummaryCount.mappingPropertyObject(res.data),
          };
        }
        console.log('ERROR: newFeedService/getProspectSummaryCount', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getProspectSummaryCount', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getProspectSummaryCount' };
      });
  }

  getListCurrentCompetitions(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getListCurrentCompetitions()
      .then(res => {
        if (res.success) {
          const listCompetitions: any[] = [];
          if (res.data && res.data.items.length > 0) {
            res.data.items.forEach((itm: any) => {
              listCompetitions.push(competitionItem.mappingPropertyObject(itm));
            });
          }
          return { success: res.success, data: listCompetitions };
        }
        console.log('ERROR: newFeedService/getListCurrentCompetitions', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getListCurrentCompetitions', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getListCurrentCompetitions' };
      });
  }

  getRecent(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getRecent()
      .then(res => {
        if (res.success) {
          const users: any[] = [];
          res.data.items.map((itm: any) => users.push(recentUsers.mappingObject(itm)));
          return { success: res.success, data: users };
        }
        console.log('ERROR: newFeedService/getActivitySumaryUsers', res);
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getActivitySumaryUsers', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getActivitySumaryUsers' };
      });
  }

  getAnnouncementBanner(): Promise<IApiResponse<any>> {
    return newFeedApi
      .getAnnouncementBanner()
      .then(res => {
        if (res.success && res.data) {
          return {
            success: res.success,
            data: banner.mappingObject(res.data?.Mobile),
            dataDesktop: banner.mappingObject(res.data?.Desktop),
          };
        }
        return res;
      })
      .catch(e => {
        console.warn('ERROR: Catch Error newFeedService/getAnnouncementBanner', e);
        return { success: false, message: 'ERROR: Catch Error newFeedService/getAnnouncementBanner' };
      });
  }
}

export default new NewFeedService();
